import React from "react";
import { Upload, Icon } from "antd";

import { compressImageRequest } from "../compressImageRequest";
import { getImageLink } from "../../../../services/asset";
import ImageCard from "./ImageCard";
import styles from "./singlePhoto.scss";

// eslint-disable-next-line max-lines-per-function
const SinglePhoto = ({
  uploadClassName,
  previewCardClassName,
  isCompressed,
  isDisabled,
  files,
  onChange,
  onMove,
  onPreview,
  onRemove,
  beforeUpload,
  action,
  accept
}) => {
  const file = files[0];

  return (
    <React.Fragment>
      {file && (
        <ImageCard
          className={`${styles.imageCard} ${previewCardClassName}`}
          disabled={isDisabled}
          draggable={false}
          index={0}
          onMove={onMove}
          status={file.status}
          imageUrl={
            file.url || (file.response ? getImageLink(file.response[0]) : null)
          }
          onPreview={onPreview}
          onRemove={onRemove}
        />
      )}

      <Upload
        disabled={isDisabled}
        action={action}
        className={`single-photos-uploader ${styles.uploader} ${uploadClassName}`}
        listType="picture-card"
        fileList={files}
        onPreview={onPreview}
        onChange={onChange}
        beforeUpload={beforeUpload}
        accept={accept}
        multiple={false}
        /* eslint-disable-next-line */
        customRequest={compressImageRequest.bind(this, isCompressed)}
        showUploadList={false}
      >
        {!file && <Icon type="plus" className={styles.addPhoto} />}
      </Upload>
    </React.Fragment>
  );
};

SinglePhoto.defaultProps = {
  uploadClassName: "",
  onChange: () => null,
  isCompressed: true,
  isDisabled: false,
  previewCardClassName: ""
};

export default SinglePhoto;



// WEBPACK FOOTER //
// ./src/components/FormControls/PhotoUploader/SinglePhoto/index.tsx